import React from "react";
import { format } from "date-fns";
import { styles } from "../../styles";

const formatDate = (s) => format(s, "DD.MM.YYYY HH:mm");

const RideDateField = ({ ride, type }) => {
  if (type === "createdAt") {
    return <div style={styles.title}>{formatDate(ride[type])}</div>;
  }
  if (ride[`${type}From`] === ride[`${type}To`]) {
    return <div style={styles.subtitle}>{formatDate(ride[`${type}From`])}</div>;
  }
  return (
    <div>
      {formatDate(ride[`${type}From`])}
      <br />
      {formatDate(ride[`${type}To`])}
    </div>
  );
};

export default RideDateField;



// WEBPACK FOOTER //
// ./src/components/fields/RideDateField.js